<ng-container *ngIf="property">
  <div
    class="wrapper"
    [ngClass]="{
      'off-market': !!property.offMarket,
      unverified: !property.isVerified
    }"
  >
    <span *ngIf="property.offMarket">Off-market</span>
    <ng-container *ngIf="!property.offMarket">
      <span *ngIf="property.isVerified">Verified</span>
      <span *ngIf="!property.isVerified">Unverified</span>
    </ng-container>
  </div>
</ng-container>
